(function () {
  function isElement(node) {
    return node && node.nodeType === 1;
  }

  function nextElementSkippingWhitespace(node) {
    let n = node.nextSibling;
    while (n && (!isElement(n) && (!n.textContent || !n.textContent.trim()))) n = n.nextSibling;
    return isElement(n) ? n : null;
  }

  function getSectionRoot(el) {
    return el.closest('[id^="shopify-section-"]') || el;
  }

  // 创建双图轮播容器
  function createDoubleCarouselContainer(banners, originalSections) {
    const container = document.createElement('div');
    container.className = 'product-banner-double-carousel';
    
    // 轮播主体
    const carouselInner = document.createElement('div');
    carouselInner.className = 'carousel-inner';
    
    // 计算总共有多少组（每组2张）
    const totalGroups = Math.ceil(banners.length / 2);
    
    // 创建每一组
    for (let i = 0; i < totalGroups; i++) {
      const group = document.createElement('div');
      group.className = 'carousel-group';
      group.setAttribute('data-group', i);
      if (i === 0) group.classList.add('active');
      
      // 左列
      const leftCol = document.createElement('div');
      leftCol.className = 'carousel-col';
      const firstBanner = banners[i * 2];
      if (firstBanner && firstBanner.cloneNode) {
        leftCol.appendChild(firstBanner.cloneNode(true));
      }
      
      // 右列
      const rightCol = document.createElement('div');
      rightCol.className = 'carousel-col';
      const secondBanner = banners[i * 2 + 1];
      if (secondBanner && secondBanner.cloneNode) {
        rightCol.appendChild(secondBanner.cloneNode(true));
      } else if (secondBanner === undefined && banners.length % 2 !== 0) {
        rightCol.style.opacity = '0';
        rightCol.style.pointerEvents = 'none';
      }
      
      group.appendChild(leftCol);
      group.appendChild(rightCol);
      carouselInner.appendChild(group);
    }
    
    container.appendChild(carouselInner);
    
    // 大于1组时才添加导航
    if (totalGroups > 1) {
      const prevBtn = document.createElement('button');
      prevBtn.className = 'carousel-prev';
      prevBtn.innerHTML = '❮';
      
      const nextBtn = document.createElement('button');
      nextBtn.className = 'carousel-next';
      nextBtn.innerHTML = '❯';
      
      container.appendChild(prevBtn);
      container.appendChild(nextBtn);
      
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'carousel-dots';
      for (let i = 0; i < totalGroups; i++) {
        const dot = document.createElement('span');
        dot.className = 'carousel-dot';
        if (i === 0) dot.classList.add('active');
        dot.setAttribute('data-index', i);
        dotsContainer.appendChild(dot);
      }
      container.appendChild(dotsContainer);
      
      initCarousel(container, totalGroups);
    }
    
    originalSections.forEach(section => {
      if (section && section.style) {
        section.style.display = 'none';
      }
    });
    
    return container;
  }
  
  function initCarousel(container, totalGroups) {
    let currentIndex = 0;
    const groups = container.querySelectorAll('.carousel-group');
    const prevBtn = container.querySelector('.carousel-prev');
    const nextBtn = container.querySelector('.carousel-next');
    const dots = container.querySelectorAll('.carousel-dot');
    
    function showGroup(index) {
      groups.forEach((group, i) => {
        if (i === index) {
          group.classList.add('active');
        } else {
          group.classList.remove('active');
        }
      });
      
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      currentIndex = index;
    }
    
    function nextGroup() {
      let newIndex = currentIndex + 1;
      if (newIndex >= totalGroups) newIndex = 0;
      showGroup(newIndex);
    }
    
    function prevGroup() {
      let newIndex = currentIndex - 1;
      if (newIndex < 0) newIndex = totalGroups - 1;
      showGroup(newIndex);
    }
    
    prevBtn.addEventListener('click', prevGroup);
    nextBtn.addEventListener('click', nextGroup);
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => showGroup(index));
    });
  }
  
  function mergeProductBannersIntoGrid(root = document) {
    if (window.Shopify && window.Shopify.designMode) return;
    
    const markers = Array.from(root.querySelectorAll('.js-product-banner-instance'));
    if (!markers.length) return;
    
    const roots = [];
    const seen = new Set();
    for (const m of markers) {
      const r = getSectionRoot(m);
      if (r && !seen.has(r)) {
        seen.add(r);
        roots.push(r);
      }
    }
    
    const validBanners = [];
    for (let i = 0; i < roots.length; i++) {
      const section = roots[i];
      if (!section.querySelector('.js-product-banner-instance')) continue;
      if (section.closest('.product-banner-double-carousel')) continue;
      validBanners.push(section);
    }
    
    if (validBanners.length === 2) {
      console.log('2个banner，使用两列布局');
      const container = document.createElement('div');
      container.className = 'product-banner-two-column';
      
      const col1 = document.createElement('div');
      col1.className = 'product-banner-col';
      col1.appendChild(validBanners[0].cloneNode(true));
      
      const col2 = document.createElement('div');
      col2.className = 'product-banner-col';
      col2.appendChild(validBanners[1].cloneNode(true));
      
      container.appendChild(col1);
      container.appendChild(col2);
      
      validBanners[0].parentNode.insertBefore(container, validBanners[0]);
      validBanners.forEach(b => b.style.display = 'none');
      
    } else if (validBanners.length > 2) {
      console.log(validBanners.length + '个banner，使用双图轮播');
      const firstBanner = validBanners[0];
      const carousel = createDoubleCarouselContainer(validBanners, validBanners);
      firstBanner.parentNode.insertBefore(carousel, firstBanner);
    }
  }
  

  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      mergeProductBannersIntoGrid(document);
    });
  } else {
    mergeProductBannersIntoGrid(document);
  }
})();